import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Store} from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import {
    ELandlineConsumptionActions,
    GetLandlineConsumption, GetLandlineConsumptionFailure,
    GetLandlineConsumptionSuccess
} from '../actions/land-line-consumption.actions';
import { LandLinesService } from '../../services/land-lines.service';
import { LandlineConsumptionInterface } from '../../models/landline-consumption.interface';

@Injectable()
export class LandLineConsumptionEffects extends AbstractEffects {

    landLine: string = null;

    constructor(
        private actions: Actions,
        private landlineService: LandLinesService,
        public override store: Store<any>
    ) {
        super(store);
    }

    getLandlineConsumption = createEffect(() => this.actions.pipe(
        ofType<GetLandlineConsumption>(ELandlineConsumptionActions.GetLandlineConsumption),
        tap(params => { this.landLine = params.landLine; }),
        switchMap(() => this.landlineService.getLandLineConsumption(this.landLine)),
        switchMap((response: LandlineConsumptionInterface) => of(new GetLandlineConsumptionSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetLandlineConsumption(this.landLine));
            } else if (error.error['error_message'] !== 'invalid_customer_landline') {
                this.DisplayMessage('error_with_retry', 400, new GetLandlineConsumptionFailure());
            } else {
                this.store.dispatch(new GetLandlineConsumptionFailure());
            }
            return throwError(error);
        })
    ));
}
